import { Component, OnInit, Input } from '@angular/core';
import { CommonService } from '../../../../shared/providers/common.service';
import { AuthenticationService } from '../../../../shared/auth/authentication.service';
import { PropertyDocument } from '../../../../shared/models/SavePropertyInputModel';
import { ValidationService } from '../../../../shared/providers/validation.service';
export interface IPropertySaleHistory {
    Id: number;
    PropertyId: number;
    SaleDate?: Date;
    SalePrice?: number;
    SaleCapRate?: number;
    SalePSF?: number;
    BrokerageId: number;
    AutoPopulated?: boolean;
    AutoCalcPSF?: boolean;
    AutoCalcCapRate?: boolean;
    NOI: number;
    BuildingSize: number;
    IsAutoGenerated?: boolean;

    DateOnMarket?: Date;
    YearOnMarket?: number;
    MonthOnMarket?: number;
    DayOnMarket?: number;
    AskingPrice?: number;
    AskingCapRate?: number;
    DiscountToAsking?: number;

    BuyerName: string;
    BuyerBrokerageName: string;
    BuyerBrokerName: string;
    SellerName: string;
    SellerBrokerageName: string;
    SellerBrokerName: string;
    RemainingTermYear?: number;
    RemainingTermMonth?: number;
    RemainingTermDay?: number;
    Is1031ExchangeBuyer: boolean | false;
    SaleCharacteristicsId?: number[];
    LTV?: number;
    InterestRate?: number;
    Amortization?: number;
    Term?: number;
    SalesNotes: string;
    AutoCalcDiscount?: boolean;
    GuarantorId?: number;
    SPRatingId?: number;
    MoodyRatingId?: number;
    FitchRatingId?: number;
    LeaseStructureId?: number;
    RentEscalationPercentage?: number;
    RentEscalationPeriod?: number;
    OptionNumber?: number;
    OptionLength?: number;
    SalesNOI?: number;
    BuyerBrokerageId: number;

    Documents?: PropertyDocument[];
    RemovedDocuments?: number[];
    SelectedFiles?: string[]
    Event?: string;
    EventId?: number;
    SaleCharacteristics?: string;
    showChild?: boolean;
    IsAdd?: boolean;
    Index?: number;
    GuarantorName?: string;
    SPRating?: string;
    MoodyRating?: string;
    FitchRating?: string;
    LeaseStructureName?: string;
    ShowDoc?: boolean;
    CreatedBy?: number;
}
@Component({
  selector: 'app-sale-history-detail',
  templateUrl: './sale-history-detail.component.html',
  styleUrls: ['./sale-history-detail.component.css']
})
export class SaleHistoryDetailComponent implements OnInit {

    constructor(public authService: AuthenticationService, public _validationService: ValidationService) { }

    @Input() historyFields= [] as any;
    iPropertySaleHistory = {} as IPropertySaleHistory;

    ngOnInit() {
        this.iPropertySaleHistory.AskingPrice = this.historyFields.filter(i => i.Name == 'Asking Price')[0].NewValue;
        this.iPropertySaleHistory.SalePrice = this.historyFields.filter(i => i.Name == 'Sale Price')[0].NewValue;
        this.iPropertySaleHistory.SaleDate = this.historyFields.filter(i => i.Name == 'Date')[0].NewValue;
        this.iPropertySaleHistory.SaleCapRate = this.historyFields.filter(i => i.Name == 'Sale Cap Rate')[0].NewValue;
        this.iPropertySaleHistory.AskingCapRate = this.historyFields.filter(i => i.Name == 'Asking Cap Rate')[0].NewValue;
        this.iPropertySaleHistory.BuyerName = this.historyFields.filter(i => i.Name == 'Buyer')[0].NewValue;
      this.iPropertySaleHistory.BuyerBrokerageName = this.historyFields.filter(i => i.Name == 'Buyer Brokerage')[0].NewDropdownValue;
        this.iPropertySaleHistory.BuyerBrokerName = this.historyFields.filter(i => i.Name == 'Buyer Broker')[0].NewValue;
        this.iPropertySaleHistory.SellerName = this.historyFields.filter(i => i.Name == 'Seller')[0].NewValue;
        this.iPropertySaleHistory.SellerBrokerName = this.historyFields.filter(i => i.Name == 'Seller Broker')[0].NewValue;
      this.iPropertySaleHistory.SellerBrokerageName = this.historyFields.filter(i => i.Name == 'Seller Brokerage')[0].NewDropdownValue;
        this.iPropertySaleHistory.RemainingTermYear = this.historyFields.filter(i => i.Name == 'Remaining Term')[0].NewValue;

        this.iPropertySaleHistory.DateOnMarket = this.historyFields.filter(i => i.Name == 'Property Brought To Market')[0].NewValue;
        this.iPropertySaleHistory.DiscountToAsking = this.historyFields.filter(i => i.Name == 'Discount To Asking')[0].NewValue;
        this.iPropertySaleHistory.YearOnMarket = this.historyFields.filter(i => i.Name == 'Time on Market')[0].NewValue;
        this.iPropertySaleHistory.SalePSF = this.historyFields.filter(i => i.Name == 'PSF')[0].NewValue;
        this.iPropertySaleHistory.GuarantorName = this.historyFields.filter(i => i.Name == 'Guarantor')[0].NewDropdownValue;
        this.iPropertySaleHistory.SPRating = this.historyFields.filter(i => i.Name == 'SP Rating')[0].NewDropdownValue;
        this.iPropertySaleHistory.MoodyRating = this.historyFields.filter(i => i.Name == 'Moody Rating')[0].NewDropdownValue;
        this.iPropertySaleHistory.FitchRating = this.historyFields.filter(i => i.Name == 'Fitch Rating')[0].NewDropdownValue;
        this.iPropertySaleHistory.LeaseStructureName = this.historyFields.filter(i => i.Name == 'Lease Structure')[0].NewDropdownValue;
        this.iPropertySaleHistory.SalesNOI = this.historyFields.filter(i => i.Name == 'NOI')[0].NewValue;

        this.iPropertySaleHistory.RentEscalationPercentage = this.historyFields.filter(i => i.Name == 'Rent Escalation Percentage')[0].NewValue;

        this.iPropertySaleHistory.RentEscalationPeriod = this.historyFields.filter(i => i.Name == 'Rent Escalation Period')[0].NewValue;

        this.iPropertySaleHistory.OptionNumber = this.historyFields.filter(i => i.Name == 'Option Number')[0].NewValue;

        this.iPropertySaleHistory.OptionLength = this.historyFields.filter(i => i.Name == 'Option Length')[0].NewValue;

        this.iPropertySaleHistory.SalesNotes = this.historyFields.filter(i => i.Name == 'Notes')[0].NewValue;
  }

}
